import { Component, Input, OnChanges, OnInit, SimpleChanges, } from "@angular/core";
import { Donation } from "../donation/donation";
import { OptionService } from "../option/option.service";
import { ShopCartService } from "../shop/shop.cart.service";
import { FormControl, FormGroup } from "@angular/forms";

@Component({
    selector: 'amount-extra',
    templateUrl: './amount.extra.component.html'
})
export class AmountExtraComponent implements OnInit, OnChanges {
    /**
     * The current donation object
     */
    @Input() donation: Donation;

    /**
     * formgroup for the input elements
     */
    @Input() form: FormGroup;

    /**
     * flag if the cart should be used
     */
    @Input() useCart: boolean = false;

    /**
     * amount of the donation
     */
    @Input() amount: number = 0;

    /**
     * if set the user should be asked for an extra amount
     */
    extraAmount: number;

    /**
     * the type of the extra amount
     */
    extraAmountType: 'money' | 'percent';

    /** 
     * extra amount in percent
     */
    extraAmountPercent: number;

    /**
     * extra amount in money
     */
    extraAmountMoney: number;

    /**
     * flag if extra amount is active
     */

    extraAmountActive: boolean;

    /**
     * constructor
     * @param optionService
     */
    constructor(private optionService: OptionService, private shopCartService: ShopCartService) { }

    /**
     * @inheritDoc
     */
    ngOnInit(): void {
        // check if we should ask for an extra amount
        this.extraAmount = this.optionService.getOption('extra_amount') ? Number(parseFloat(this.optionService.getOption('extra_amount')).toFixed(2)) : null;

        if (!this.extraAmount) {
            return;
        }

        // get the type - default is money
        this.extraAmountType = this.optionService.getOption('extra_amount_unit') || 'money';

        // check if the extra amount is active
        this.extraAmountActive = this.donation.extraAmount > 0;

        // add the extra amount control to the form
        this.form.addControl('extra_amount', new FormControl(this.donation.extraAmount > 0));

        if (this.useCart) {
            this.calculateCartAmount();
            // subscribe to the shop cart service
            this.shopCartService.itemsUpdated.subscribe(() => {
                this.calculateCartAmount();
            });
        } else {
            // calculate the money and percentage
            this.calulateMoneyAndPercentage(this.amount);
        }
    }

    /**
     * @inheritdoc
     * @param changes 
     */
    ngOnChanges(changes: SimpleChanges): void {
        // check if the amount has changed
        if (changes.amount && changes.amount.currentValue) {
            if (this.useCart) {
                this.calculateCartAmount();
            } else {
                this.calulateMoneyAndPercentage(this.amount);
            }
        }
    }

    /**
     * calculate the amount for the cart
     * we need to add the amount here from a possible custom donation
     */
    calculateCartAmount(): void {
        const basePrice = this.shopCartService.getPriceWithoutCustomProducts() + this.amount;
        this.calulateMoneyAndPercentage(basePrice);
    };

    /**
     *  calculate the money and percentage
     */
    calulateMoneyAndPercentage(basePrice: number): void {
        
        if (this.extraAmountType === 'percent') {
            this.extraAmountPercent = this.extraAmount;
            this.extraAmountMoney = basePrice * this.extraAmountPercent / 100;
        } else {
            this.extraAmountMoney = this.extraAmount;
            this.extraAmountPercent = this.extraAmount / basePrice * 100;
        }
        // if it is active update the extra amount for the donation
        if (this.extraAmountActive) {
            this.donation.extraAmount = Number(this.extraAmountMoney.toFixed(2));
        }
    }

    /**
     * toggles the extra amount on and off
     * @param value
     */
    toggleExtraAmount(value: boolean): void {
        // set the extra amount to the donation
        this.donation.extraAmount = value === true ? Number(this.extraAmountMoney.toFixed(2)) : 0;
        this.extraAmountActive = value;
    }
}
